// Standing formatting rule (see CLAUDE.md "Number formatting"): English/UK
// comma thousands-grouping everywhere; no decimals once the value is above
// 10, regardless of the underlying precision.
export function decimalsForValue(value) {
  const num = Number(value);
  if (!Number.isFinite(num)) return 0;
  return Math.abs(num) > 10 ? 0 : (String(value).split(".")[1]?.length || 0);
}

export function formatNumber(value, decimals = decimalsForValue(value)) {
  const num = Number(value);
  if (!Number.isFinite(num)) return value;
  return num.toLocaleString("en-GB", { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}
